import { type FC } from "react";

import { redirectToUrl } from "../../utils/url/urlUtils";
import { InformationPage } from "../../common/components/informationPage/InformationPage";
import { IMG_QUOTE_CONFIRMATION } from "../../utils/url/staticResources";
import { useTranslation } from "react-i18next";

const QuoteConfirmationPage: FC = () => {
  const { t } = useTranslation();

  return (
    <InformationPage
      title={<h1 className={"display-small mb-3 mt-60"}>{t("orderConfirmationPage.internalQuote.thankYou")}</h1>}
      btnSetup={{
        onClick: () => redirectToUrl("/my-account/quotes/search"),
        label: t("orderConfirmationPage.internalQuote.button.label"),
        id: "quoteconfirmation_bt_homepage_btn",
      }}
      imageSrc={IMG_QUOTE_CONFIRMATION}
    />
  );
};

export function createQuoteConfirmationPage() {
  return <QuoteConfirmationPage />;
}
